import { translate as t } from '@thoughtspot/i18n';
import React from 'react';
import { Content, CreateModal, Header } from '../../common';
import { LearnMore, Mode } from '../../common/constants';
import styles from '../backup-storage.module.scss';
import { actions, createNasRowData, nasEmptyStateFormFields, } from '../common/backup-storage.util';
import { pageName, TranslationsKeys, } from '../common/constants';
import { TableListWrapperComponent } from '../common/table-list-wrapper';
export const NasViewSection = ({ table, configState, isModalOpen, addClickHandler, rowDeleteClickHandler, confirmDeleteHandler, dismissModalHandler, updateTable, }) => {
    const addNasMountClickHandler = (type) => {
        addClickHandler(type);
    };
    const nasRowDeleteClickHandler = (mountPoint) => {
        rowDeleteClickHandler(mountPoint);
    };
    const nasConfirmDeleteHandler = () => {
        confirmDeleteHandler();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { title: t(TranslationsKeys.MOUNT_POINT_NAS_HEADING), subTitle: t(TranslationsKeys.MOUNT_POINT_NAS_DESCRIPTION), learnMoreKey: LearnMore.NAS, mode: Mode.VIEW, titleSize: "medium", isFullWidth: true, actions: configState.actions, actionHandler: addNasMountClickHandler }),
        isModalOpen && (React.createElement(CreateModal, { pageName: pageName, action: "deleteNas", onConfirm: nasConfirmDeleteHandler, onDismiss: dismissModalHandler })),
        table.length > 0 ? (React.createElement("div", { className: styles.tableBottomMargin },
            React.createElement(TableListWrapperComponent, { rowData: createNasRowData(table, nasRowDeleteClickHandler), typeName: "NAS", updateTable: updateTable }))) : (React.createElement(Content, { key: `backupAndStorage_${Mode.VIEW}`, config: nasEmptyStateFormFields()[0], actions: actions, actionHandler: addNasMountClickHandler, mode: Mode.VIEW, pageName: pageName, isFullWidth: true }))));
};
export const MemoizedNas = React.memo(NasViewSection);
//# sourceMappingURL=nas.js.map